import React, { Fragment } from 'react';

const RidesharingApp = () => (
  <Fragment>
    <p>
      Autzu vehicles are currently eligible to accept passenger and food
      delivery trips using the Uber Driver app.
    </p>
  </Fragment>
);

export default RidesharingApp;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/General/RidesharingApp.js